// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__nuxt .el-dialog__wrapper{align-items:center;display:flex;justify-content:center}@media(max-width:667.98px){#__nuxt .el-dialog__wrapper{box-sizing:border-box;padding-bottom:1.5rem}}#__nuxt .el-dialog__wrapper .el-dialog{margin:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98"
};
module.exports = ___CSS_LOADER_EXPORT___;
